import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'es-details-subcard',
  templateUrl: './es-details-subcard.component.html',
  styleUrls: ['./es-details-subcard.component.scss'],
})
export class EsDetailsSubcardComponent {
  @Input() public mode: 'primary' | 'secondary' = 'primary';
  @Input() public title: string = '';
  @Input() public canEdit: boolean = false;
  @Input() public isFooter: boolean = false;
  @Input() public isMissing: boolean = false;
  @Input() public missingMessageText: string = 'ENTRY_SUMMARY.REQUIRED_INFORMATION';
  @Output() public edit: EventEmitter<any> = new EventEmitter<any>();

  constructor() {}
}
